import React from "react"

import styled, { css } from "styled-components"
import { ProductInfo } from "../../../../../styles/styles"
import NumberFormat from "react-number-format"
import RowInfo from "../../../../RowInfo"

const SProductInfo = styled(ProductInfo)`
  ${({ theme }) => {
    return css`
      padding: 0;
      .flextext {
        margin: 0;
        ul {
          padding: 0;
          li {
          }
        }
      }
    `
  }}
`

function Payment({ data }) {
  const {
    TicketAccountOrderDetail: {
      isDiscount,
      discountPrice,
      price,

      totalCount,
      totalPrice,
    },
  } = data

  const productPrice = isDiscount ? price - discountPrice : price
  return (
    <>
      <SProductInfo>
        <RowInfo
          textLeft={"금액"}
          textRight={
            <>
              <b>
                <NumberFormat
                  displayType={"text"}
                  value={productPrice}
                  thousandSeparator={true}
                />
              </b>
              드림
            </>
          }
        />
        <RowInfo
          border={"bottom"}
          textLeft={"수량"}
          textRight={
            <>
              <b>{totalCount}</b>개
            </>
          }
        />
        <RowInfo
          total={"total"}
          border={"bottom"}
          textLeft={"총 결제금액"}
          textRight={
            <>
              <b>
                <NumberFormat
                  displayType={"text"}
                  value={totalPrice}
                  thousandSeparator={true}
                />
              </b>
              드림
            </>
          }
        />
      </SProductInfo>
    </>
  )
}

export default Payment
